__turbopack_context__.v({
  "back": "_7ouoJa_back",
  "clockwise": "_7ouoJa_clockwise",
  "counterclockwise": "_7ouoJa_counterclockwise",
  "flip": "_7ouoJa_flip",
  "flipContainer": "_7ouoJa_flipContainer",
  "flipped": "_7ouoJa_flipped",
  "flipper": "_7ouoJa_flipper",
  "front": "_7ouoJa_front",
});
